export default __webpack_public_path__ + "static/media/ppp.08b3ab8c.png";